import React from 'react';
import { View } from 'react-native-web';
import {
  addPathToList,
  disabled_customer_will_skip, File_type,
  getSubCategoryId,
  select_operator_asset_note,
  select_operator_layout_text, select_operator_layout_title,
  select_operator_paragraph,
  select_operator_switch,
  select_operator_title,
} from '../utils/DictionaryManagementUtils';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import NoteMessage from '../components/PanelsComponents/Text/NoteMessage';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import RadioPanelAdvance from '../components/PanelsComponents/Buttons/RadioPanelAdvance';
import AssetRequirements from '../components/PanelsComponents/General/AssetRequirements';

const Panel_H08_TopUpSelectOperator = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'select_mobile_operator_title',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];
  const { operator } = service;
  const onValueChanged = (key, value) => {
    operator[key] = value;
    onConfigChanged();
  };
  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={select_operator_title}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/operator/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/operator/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={select_operator_paragraph}
      language={language}
      disableEditElements={!operator.customer_should_select_a_mobile_operator}
    >
      <SwitcherPanel
        text={select_operator_switch}
        value={operator.customer_should_select_a_mobile_operator}
        onValueChanged={(value) => {
          onValueChanged('customer_should_select_a_mobile_operator', value);
        }}
        marginTop={8}
        marginBottom={30}
      />
      {operator.customer_should_select_a_mobile_operator
        ? (
          <View>
            <RadioPanelAdvance
              title={select_operator_layout_title}
              chosenValue={operator.design_the_layout}
              valuesMap={select_operator_layout_text}
              onValueChanged={(value) => {
                onValueChanged('design_the_layout', value);
              }}
            />
            <AssetRequirements paragraph={select_operator_asset_note} details={File_type} />
          </View>
        )
        : <NoteMessage language={language}>{disabled_customer_will_skip}</NoteMessage>}
    </FullPagePanel>
  );
};

export default Panel_H08_TopUpSelectOperator;
